import { close, hide, show } from './utils';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        showAlert(): HTMLElement;
        hideAlert(): HTMLElement;
        closeAlert(): HTMLElement;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.showAlert = function (): HTMLElement {
    show(this);

    return this;
};

HTMLElement.prototype.hideAlert = function (): HTMLElement {
    hide(this);

    return this;
};

HTMLElement.prototype.closeAlert = function (): HTMLElement {
    close(this);

    return this;
};
